import React, { useContext, useReducer, useState } from "react";
import { Col, Modal, Row, Spinner } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { Helmet } from "react-helmet-async";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Store } from "../Store";
import AlertBox from "../components/AlertBox";
import LoadingBox from "../components/LoadingBox";
import useAxios from "../hooks/useAxios";
import useUsers from "../hooks/useUsers";
import { getError } from "../utils";
import BusinessUserScreen from "./BusinessUserScreen";

const reducer = (state, action) => {
  switch (action.type) {
    case "DELETE_REQUEST":
      return { ...state, loadingDelete: true, successDelete: false };
    case "DELETE_SUCCESS":
      return {
        ...state,
        loadingDelete: false,
        successDelete: true,
      };
    case "DELETE_FAIL":
      return { ...state, loadingDelete: false };
    case "DELETE_RESET":
      return { ...state, loadingDelete: false, successDelete: false };
    default:
      return state;
  }
};
export default function UserListScreen() {
  const axios = useAxios();
  const [loading, , setLoadUsers] = useUsers();
  const navigate = useNavigate();
  const [{ loadingDelete }, dispatch] = useReducer(reducer, {
    loadingDelete: false,
  });

  const { state } = useContext(Store);
  const { users } = state;
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);
  const [user, setUser] = useState();

  const confirmDeleteHandler = (user) => {
    setUserToDelete(user);
    setShowConfirmModal(true);
  };

  const deleteHandler = async () => {
    try {
      dispatch({ type: "DELETE_REQUEST" });
      await axios.delete(`/api/busers/${userToDelete._id}`);
      toast.success("User deleted successfully");
      setLoadUsers(true);
      setShowConfirmModal(false);
      dispatch({ type: "DELETE_SUCCESS" });
    } catch (error) {
      toast.error(getError(error));
      dispatch({
        type: "DELETE_FAIL",
      });
    }
  };

  return (
    <div className="medium-container">
      <Helmet>
        <title>Kullanıcılar</title>
      </Helmet>

      {!isTabletOrMobile && (
        <>
          <h1 className="my-3 text-muted">Kullanıcılar</h1>
          <hr className="hr"></hr>
        </>
      )}
      <Row>
        <Col className="col text-end">
          <div>
            <Button
              type="button"
              variant="light"
              className="text-primary border-primary"
              onClick={() => {
                setUser(null);
                setShowEditModal(true);
              }}
            >
              <i className="fas fa-plus"></i>
              {!isTabletOrMobile && <>&nbsp; Kullanıcı Oluştur</>}
            </Button>
          </div>
        </Col>
      </Row>

      {loading ? (
        <LoadingBox>Kullanıcılar Yükleniyor</LoadingBox>
      ) : users && users.length > 0 ? (
        <table className="table">
          <thead>
            <tr>
              <th>Adı</th>
              <th>Yönetici mi</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr key={user._id}>
                <td>{user.name}</td>
                <td>
                  {user.role === "business_admin" ||
                  user.role === "business_owner"
                    ? "Evet"
                    : "Hayır"}
                </td>
                <td className="text-end">
                  <Button
                    type="button"
                    className="border-success text-success"
                    variant="light"
                    onClick={() => {
                      setShowEditModal(true);
                      setUser(user);
                    }}
                  >
                    {!isTabletOrMobile && <>Güncelle</>}{" "}
                    <i className="fas fa-edit"></i>
                  </Button>
                  &nbsp;
                  {loadingDelete && userToDelete._id === user._id ? (
                    <Spinner
                      animation="border"
                      role="status"
                      className="text-primary"
                    />
                  ) : (
                    <Button
                      type="button"
                      className="border-danger text-danger"
                      variant="light"
                      onClick={() => confirmDeleteHandler(user)}
                    >
                      {!isTabletOrMobile && <>Sil</>}{" "}
                      <i className="fas fa-trash-alt"></i>
                    </Button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <AlertBox primary>
          <span>Sistemde kayıtlı kullanıcınız bulunmamaktadır</span>
        </AlertBox>
      )}

      <Modal
        show={showConfirmModal}
        onHide={() => setShowConfirmModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Kullanıcıyı Sil</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loadingDelete ? (
            <div>
              <LoadingBox>Siliniyor!</LoadingBox>
            </div>
          ) : (
            <p>Silmek istediğinize emin misiniz?</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowConfirmModal(false)}
          >
            Vazgeç
          </Button>
          <Button variant="danger" onClick={deleteHandler}>
            Sil
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showEditModal}
        onHide={() => setShowEditModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {user && user._id
              ? "Kullanıcıyı Güncelle"
              : "Yeni Kullanıcı Oluştur"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <BusinessUserScreen
            userId={user ? user._id : "0"}
            closeHandler={() => setShowEditModal(false)}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
}
